
export default {
    name: 'CopyActionsContainer',

    props: {
        markdownContent: {
           type: String,
           default: '',
        }
    },

    data() {
        return {
            copiedType: null,
        };
    },

    created() {
        this.copyTypes = {
            plainText: 1,
            richText: 2,
            markdown: 3,
        };
        this.copiedTypeTimeout = null;
    },

    beforeDestroy() {
        if (this.copiedTypeTimeout) {
            clearTimeout(this.copiedTypeTimeout);
        }
    },

    methods: {
        setCopiedType(type) {
            if (this.copiedTypeTimeout) {
                clearTimeout(this.copiedTypeTimeout);
            }
            this.copiedType = type;
            this.copiedTypeTimeout = setTimeout(() => {
                this.copiedType = null;
            }, 5000);
        },

        copyFallback(content, type) {
            const textarea = document.createElement('textarea');
            textarea.value = content;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'absolute';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);

            // Select and copy the text
            textarea.select();
            const success = document.execCommand('copy');
            document.body.removeChild(textarea);

            if (success) {
                this.setCopiedType(type);
                return;
            }

            this.$store.commit('snackbar/updateType', 'error');
            this.$store.commit('snackbar/updateMessage', this.$t('component.copyActions.copyFailed'));
        },

        async handleCopyPlainText() {
            const plainText = this.markdownContent
                .replace(/#+\s/g, '') // Remove headings
                .replace(/\*\*(.*?)\*\*/g, '$1') // Remove bold
                .replace(/\*(.*?)\*/g, '$1') // Remove italic
                .replace(/\[(.*?)\]\(.*?\)/g, '$1') // Remove links
                .replace(/`(.*?)`/g, '$1') // Remove inline code
                .replace(/```[\s\S]*?```/g, '') // Remove code blocks
                .replace(/>\s(.*)/g, '$1') // Remove blockquotes
                .replace(/- /g, '') // Remove list markers
                .replace(/\d+\.\s/g, ''); // Remove numbered list markers
            
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(plainText);
                this.setCopiedType(this.copyTypes.plainText);
                return;
            }

            this.copyFallback(plainText, this.copyTypes.plainText);
        },

        async handleCopyRichText() {
            const html = this.$md.render(this.markdownContent);  
            // Check if Clipboard API is available
            if (navigator.clipboard && navigator.clipboard.write) {
                const blob = new Blob([html], { type: 'text/html' });  
                const data = [new ClipboardItem({ 'text/html': blob })];  
                await navigator.clipboard.write(data);  
                this.setCopiedType(this.copyTypes.richText);  
                return;
            }

            // Fallback to plain text with some formatting preserved  
            const richText = html  
                .replace(/<[^>]*>/g, '') // Remove HTML tags
                .replace(/&nbsp;/g, ' ') // Replace non-breaking spaces
                .replace(/&amp;/g, '&') // Replace HTML entities
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>');

            this.copyFallback(richText, this.copyTypes.richText);
        },

        async handleCopyMarkdown() {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(this.markdownContent);
                this.setCopiedType(this.copyTypes.markdown);
                return;
            }
            this.copyFallback(this.markdownContent, this.copyTypes.markdown);
        },
    },
}
